import React, { useState, useEffect } from "react";
import Extra from "../../../../APIController/Extra";
import ExtraForm from "../Forms/ExtrasForm";
import { useModal } from "../../../../Components/Modal";
import Text from "../../../../Components/Text";
import CrudPage from "../../../../Components/CrudPage";

function ExtraManagement() {
    const { fetchExtras, deleteExtra } = Extra()

    /* Modal Loader */
    const { ModalView, openModal, closeModal } = useModal()
    const [extras, setExtras] = useState([])


    useEffect(() => {
        fetchExtraData()
    }, [])

    const fetchExtraData = async () => {
        const data = await fetchExtras()
        setExtras(data)
    }

    const formActions = () => {
        fetchExtraData()
        closeModal()
    }

    /* Add Button Click helper */
    const handleAddClick = (e) => {
        e.preventDefault();
        openModal(<ExtraForm afterAction={() => formActions()} />)
    }

    const handleEditClick = async (e, extra) => {
        e.preventDefault()
        openModal(<ExtraForm selectedExtra={extra} afterAction={() => formActions()} />)
    }

    const handleDeleteClick = async (e, extra) => {
        await deleteExtra(extra.id)
        fetchExtraData()
    }

    /* rendering view */
    const MainView = () => (
        <>
            <CrudPage 
                title={"Extras"}
                items={extras}
                crudActions={[
                    { type: "edit", color: "black", action: handleEditClick, icon: "edit" },
                    { type: "delete", color: "red", action: handleDeleteClick, icon: "trash" },
                    { type: "create", color: "bg-white", action: handleAddClick }]}
                displayMethod={(extra) => (
                    <>
                        <Text type="itemmain">{extra.name}</Text>
                        <Text type="itemtext">{extra.price}</Text>
                    </>
                )}
                allowedTarget={"productsPerCategory"}
                currentTargetValue={extras.length}
                    />
            <ModalView classNames="w-auto" />
        </>
    )

    return (MainView())
}

export default ExtraManagement